import { type CongressBase, congressBaseFields } from './congressBase';
import { type UserBase, userBaseFields } from './userBase';
import { type ElectionBase, electionBaseFields } from './electionBase';
import { type PersonType, personTypeFields } from './personType';
import { type Person, personFields } from './person';
import {
  type CodeCount,
  type PersonCount,
  codeCountFields,
  personCountFields,
} from './counts';

export interface Congress extends CongressBase {
  users: UserBase[];
  elections: ElectionBase[];
  personTypes: PersonType[];
  peopleCounts: PersonCount[];
  codeCounts: CodeCount[];
}

export interface CongressWithPeople extends Congress {
  people: Person[];
}

export const congressFields = `
  ${congressBaseFields}
  users {
    ${userBaseFields}
  }
  elections {
    ${electionBaseFields}
  }
  personTypes {
    ${personTypeFields}
  }
  peopleCounts {
    ${personCountFields}
  }
  codeCounts {
    ${codeCountFields}
  }
`;

export const congressWithPeopleFields = `
  ${congressFields}
  people {
    ${personFields}
  }
`;
